import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {Box, List, ListItem, ListItemAvatar, ListItemText, Typography} from '@mui/material';
import SteddiContainer from "../General/SteddiContainer";
import SectionHeader from "../General/SectionHeader";
import SteddiInfoItem from "../General/SteddiInfoItem";
import {CalendarDays, CalendarX, Coins, Info, LineChart, User, Zap} from "lucide-react";
import {getOrderInfoAfterSign} from "../../api/SignRequests";
import Order from "../../types/Order";
import PageHeader from "../General/PageHeader";
import SignSteps from "../General/SignSteps";
import Grid2 from "@mui/material/Unstable_Grid2";
import DateHelpers, {monthNames} from "../../helpers/DateHelpers";
import SteddiButton from "../General/SteddiButton";
import {ReactComponent as CompleteIcon} from "../../images/Bestilling.svg"
import useErrorStore from "../../stores/errorStore";
import {parseEndpointError} from "../../helpers/orderHelpers";
import LoadingPage from "./Steps/LoadingPage";

function Completed() {
  let {hashId} = useParams<string>()
  const navigate = useNavigate()
  const setError = useErrorStore((state) => state.setError)
  const error = useErrorStore((state) => state.error)
  const [orderLoading, setOrderLoading] = useState(true)
  const [order, setOrder] = useState<Order | null>(null)
  const [firstPaymentDate, setFirstPaymentDate] = useState<Date | null>(null)

  useEffect(() => {
    if (hashId) {
      setOrderLoading(true)
      getOrderInfoAfterSign(hashId!).then(order => {
        console.log(order)
        setOrder(order)
        const date = DateHelpers.getFirstPaymentDate()
        setFirstPaymentDate(date)
      }).catch((e) => {
        setError(parseEndpointError(e))
      }).finally(() => setOrderLoading(false))
    }
  }, [hashId])

  useEffect(() => {
    if (error)
      navigate("error")
  }, [error])

  function handleNext() {
    if(order?.redirectUrl)
      navigate(order.redirectUrl)
    else
      window.location.href = order?.brandId == 1 ? "https://minside.fjordkraft.no" : "https://minside.trondelagkraft.no"
  }

  if (orderLoading) {
    return (
      <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
        <LoadingPage/>
      </Box>
    )
  }

  return (
    <Box pt={5}>
      <Box display="flex" alignItems="center" justifyContent="center" mb={5}>
        <CompleteIcon/>
      </Box>
      <PageHeader>Bestillingen er i boks</PageHeader>
      <SignSteps activeStep={6} amountOfSteps={7}/>
      <Grid2 container spacing={3}>
        <Grid2 xs={12}>
          <Typography align="center">Nå er alt i orden, og du får Forutsigbar betaling fra Steddi.</Typography>
        </Grid2>
        <Grid2 xs={12}>
          <Typography>Du vil få faktura i starten av hver måned. Frem til du får den første fakturaen fra Steddi, betaler du på vanlig måte hos strømleverandøren din.</Typography>
        </Grid2>
        <Grid2 xs={12}>
          <SteddiContainer>
            <SectionHeader>Oppsummering</SectionHeader>
            <List className="no-left-pad-list">
              <SteddiInfoItem title="Adresse" subtitle={<span>{order?.installations.map(i => <span key={i.meterPointId} className="capitalize-word"><span>{i.address}, {i.zipCode}</span><span>{i.postArea}</span><br/></span>)}</span>} color={"primary"} bgColor={"secondary"} icon={<Zap/>}/>
              <SteddiInfoItem title={`${order?.customer.firstName} ${order?.customer.lastName}`}
                              subtitle={<span className="capitalize-word"><span>{order?.customer.invoiceAddress}, {order?.customer.invoicePostNumber}</span> <span>{order?.customer.invoicePostArea ?? ""}</span></span>}
                              color={"primary"} bgColor={"secondary"} icon={<User/>}/>
              <SteddiInfoItem title="Månedsbeløp" subtitle={order?.estimatedMonthlyPrice ? `${order?.estimatedMonthlyPrice.toLocaleString()} kroner` : "Ukjent"} color={"primary"} bgColor={"secondary"} icon={<Coins/>}/>
              <SteddiInfoItem title="Første forfallsdato" subtitle={DateHelpers.toDateString(firstPaymentDate)} color={"primary"} bgColor={"secondary"} icon={<CalendarDays/>}/>
              <SteddiInfoItem icon={<CalendarX/>} bgColor={"secondary"}
                              title={"Betalingsfri måned"}
                              subtitle={order && order.paymentFreeMonths.length > 0 ? order.paymentFreeMonths.map(m => monthNames[m - 1]).join(", ") : "Nei"}
              />
              <SteddiInfoItem title="Saldo og transaksjonsvisning" subtitle="For å se din saldo og dine transaksjoner må du logge deg inn på strømleverandøren sin nettside."
                              color={"primary"} bgColor={"secondary"} icon={<LineChart/>}/>
            </List>
          </SteddiContainer>
        </Grid2>
        <Grid2>
          <ListItem>
            <ListItemAvatar><Info/></ListItemAvatar>
            <ListItemText>For å gjøre endringer må du logge deg inn på strømleverandøren sin side.</ListItemText>
          </ListItem>
        </Grid2>
      </Grid2>
      <Grid2 mt={5} container justifyContent="flex-end">
        <Grid2 xs={12} sm="auto">
          <SteddiButton onClick={handleNext}>Ferdig</SteddiButton>
        </Grid2>
      </Grid2>
    </Box>
  )
}

export default Completed